(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbe-hat-configurator"] && !Shopify.designMode) return;
  try {
    
  class BBEHatConfigurator {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('[data-bbe-dialog]');
      this.settings = JSON.parse(root.querySelector('[data-bbe-settings]').textContent);
      this.settings.tiers = this.parseTiers(this.settings.tiersJson);
      this.money = new Intl.NumberFormat(this.settings.locale || 'en-US', { style: 'currency', currency: this.settings.currency || 'USD' });
      this.state = {
        step: 0,
        variantId: String(this.settings.initialVariantId),
        quantity: 12,
        view: 'front',
        front: { file: null, url: '', text: '' },
        side: { enabled: false, placement: 'left', file: null, url: '', text: '' },
        back: { enabled: false, file: null, url: '', text: '' },
        style: 'standard',
        notes: '',
        placement: { x: .5, y: .39, size: .26 },
        listingImageReady: false,
        generatedMockup: { blob: null, url: '' }
      };
      this.bind();
      this.syncVariant();
      this.render();
    }

    parseTiers(value) {
      try {
        const tiers = JSON.parse(value);
        if (!Array.isArray(tiers) || !tiers.length) throw new Error();
        return tiers.sort((a, b) => Number(a.min) - Number(b.min));
      } catch {
        return [{ min: 1, discount: 0, label: 'Standard' }];
      }
    }

    query(selector) { return this.root.querySelector(selector); }
    queryAll(selector) { return [...this.root.querySelectorAll(selector)]; }
    format(value) { return this.money.format(Number(value) || 0); }

    currentVariant() {
      return this.settings.variants.find((variant) => String(variant.id) === String(this.state.variantId)) || this.settings.variants[0];
    }

    currentImageUrl() {
      const featured = this.currentVariant()?.featured_image;
      if (typeof featured === 'string') return featured;
      return featured?.src || this.settings.productImage || '';
    }

    loadListingImage() {
      const image = this.query('[data-bbe-listing-image]');
      const url = this.currentImageUrl();
      this.imageRequest = (this.imageRequest || 0) + 1;
      const request = this.imageRequest;
      this.state.listingImageReady = false;
      image.hidden = true;
      if (!url) {
        this.renderPreview();
        return;
      }
      image.onload = () => {
        if (request !== this.imageRequest) return;
        this.state.listingImageReady = true;
        this.renderPreview();
      };
      image.onerror = () => {
        if (request !== this.imageRequest) return;
        this.state.listingImageReady = false;
        this.renderPreview();
      };
      image.src = url;
    }

    syncVariant() {
      const candidates = [...document.querySelectorAll('form[action*="/cart/add"] [name="id"]')].filter((input) => !this.root.contains(input));
      const selected = candidates.find((input) => input.offsetParent !== null) || candidates[0];
      if (selected && this.settings.variants.some((variant) => String(variant.id) === String(selected.value))) this.state.variantId = String(selected.value);
      const variant = this.currentVariant();
      this.query('[data-bbe-variant-title]').textContent = variant.public_title || variant.title || '';
      this.loadListingImage();
    }

    tier() {
      return this.settings.tiers.filter((tier) => this.state.quantity >= Number(tier.min || 1)).at(-1) || this.settings.tiers[0];
    }

    estimate() {
      const variant = this.currentVariant();
      const tier = this.tier();
      const base = Number(variant.price || 0) / 100;
      const discountedBase = base * (1 - Number(tier.discount || 0) / 100);
      let addOns = 0;
      if (this.state.side.enabled) addOns += Number(this.settings.addOns.side.price || 0);
      if (this.state.back.enabled) addOns += Number(this.settings.addOns.back.price || 0);
      if (this.state.style === 'puff') addOns += Number(this.settings.addOns.puff.price || 0);
      return { tier, base: discountedBase, unit: discountedBase + addOns, total: (discountedBase + addOns) * this.state.quantity };
    }

    contentFor(view) {
      if (view === 'side') return this.state.side.enabled ? this.state.side : { text: '', url: '' };
      if (view === 'back') return this.state.back.enabled ? this.state.back : { text: '', url: '' };
      return this.state.front;
    }

    setView(view) {
      this.state.view = 'front';
      this.renderPreview();
    }

    renderPreview() {
      const view = 'front';
      const content = this.state.front;
      const artwork = this.query('[data-bbe-artwork]');
      const image = this.query('[data-bbe-artwork-image]');
      const text = this.query('[data-bbe-artwork-text]');
      const listingImage = this.query('[data-bbe-listing-image]');
      const fallbackHat = this.query('[data-bbe-fallback-hat]');
      listingImage.hidden = true;
      fallbackHat.hidden = false;
      const isDragging = artwork.classList.contains('is-dragging');
      artwork.className = `bbe-artwork bbe-artwork--${view}${isDragging ? ' is-dragging' : ''}`;
      this.queryAll('[data-bbe-hat-view]').forEach((group) => group.toggleAttribute('hidden', group.dataset.bbeHatView !== view));
      this.query('[data-bbe-preview-label]').textContent = this.settings.labels[view];
      this.query('[data-bbe-drag-hint]').hidden = view !== 'front';
      if (view === 'front') {
        artwork.style.left = `${this.state.placement.x * 100}%`;
        artwork.style.top = `${this.state.placement.y * 100}%`;
        artwork.style.width = `${this.state.placement.size * 100}%`;
        artwork.style.height = `${this.state.placement.size * 62}%`;
        artwork.style.transform = 'translate(-50%, -50%)';
        this.query('[data-bbe-artwork-size]').value = Math.round(this.state.placement.size * 100);
      } else {
        ['left', 'top', 'width', 'height', 'transform'].forEach((property) => { artwork.style[property] = ''; });
      }
      text.textContent = content.text.trim() || this.settings.labels.placeholder;
      text.hidden = Boolean(content.url);
      image.hidden = !content.url;
      if (content.url) image.src = content.url;
      else image.removeAttribute('src');
    }

    renderPricing() {
      const estimate = this.estimate();
      this.query('[data-bbe-total]').textContent = this.format(estimate.total);
      this.query('[data-bbe-unit]').textContent = this.format(estimate.unit);
      this.query('[data-bbe-review-total]').textContent = this.format(estimate.total);
      this.query('[data-bbe-review-unit]').textContent = this.format(estimate.unit);
      const discount = Number(estimate.tier.discount || 0);
      this.query('[data-bbe-tier]').textContent = `${estimate.tier.label || `${estimate.tier.min}+`} · ${discount ? `${discount}% quantity discount` : 'Standard base pricing'}`;
    }

    detail(area) {
      const value = this.state[area];
      const parts = [];
      if (value.file) parts.push(value.file.name);
      if (value.text.trim()) parts.push(`“${value.text.trim()}”`);
      return parts.join(' + ') || this.settings.labels.noArtwork;
    }

    renderReview() {
      const estimate = this.estimate();
      const variant = this.currentVariant();
      const rows = [
        [this.settings.productTitle, variant.public_title || variant.title, this.format(Number(variant.price || 0) / 100)],
        ['Front embroidery', this.detail('front'), this.settings.labels.included],
        [this.settings.addOns.side.label, this.state.side.enabled ? `${this.state.side.placement} · ${this.detail('side')}` : this.settings.labels.notAdded, this.state.side.enabled ? `+${this.format(this.settings.addOns.side.price)}` : '—'],
        [this.settings.addOns.back.label, this.state.back.enabled ? this.detail('back') : this.settings.labels.notAdded, this.state.back.enabled ? `+${this.format(this.settings.addOns.back.price)}` : '—'],
        ['Embroidery style', this.state.style === 'puff' ? this.settings.labels.puff : this.settings.labels.standard, this.state.style === 'puff' ? `+${this.format(this.settings.addOns.puff.price)}` : this.settings.labels.included],
        [`${this.state.quantity} ${this.settings.labels.hats}`, estimate.tier.label || '', this.format(estimate.total)]
      ];
      this.query('[data-bbe-review]').innerHTML = rows.map((row) => `<div class="bbe-review__row"><span><strong>${this.escape(row[0])}</strong><small>${this.escape(row[1])}</small></span><span>${this.escape(row[2])}</span></div>`).join('');
    }

    escape(value) {
      const element = document.createElement('span');
      element.textContent = String(value || '');
      return element.innerHTML;
    }

    loadImage(source) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('An image could not be loaded for the placement preview.'));
        image.crossOrigin = 'anonymous';
        image.src = source;
      });
    }

    drawContained(context, image, width, height) {
      const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
      const drawWidth = image.naturalWidth * scale;
      const drawHeight = image.naturalHeight * scale;
      context.drawImage(image, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight);
    }

    async drawFallbackHat(context, width, height) {
      const clone = this.query('[data-bbe-fallback-hat]').cloneNode(true);
      clone.removeAttribute('hidden');
      clone.removeAttribute('data-bbe-fallback-hat');
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      clone.setAttribute('width', '1200');
      clone.setAttribute('height', '864');
      clone.querySelectorAll('[data-bbe-hat-view]').forEach((group) => {
        if (group.dataset.bbeHatView === 'front') group.removeAttribute('hidden');
        else group.remove();
      });
      const style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
      style.textContent = '.bbe-hat-outline,.bbe-hat-seam,.bbe-hat-button-outline{fill:#fff;stroke:#111;stroke-width:6;stroke-linecap:round;stroke-linejoin:round}.bbe-hat-seam,.bbe-hat-button-outline{fill:none}.bbe-hat-stitch{fill:none;stroke:#111;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:13 13}';
      clone.prepend(style);
      const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(clone)], { type: 'image/svg+xml' }));
      try {
        this.drawContained(context, await this.loadImage(url), width, height);
      } finally {
        URL.revokeObjectURL(url);
      }
    }

    drawMockupText(context, value, x, y, maximumWidth) {
      const text = value.trim() || 'ARTWORK PROVIDED';
      let size = 70;
      context.fillStyle = '#d9342b';
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.font = `900 ${size}px Arial, sans-serif`;
      while (size > 30 && context.measureText(text).width > maximumWidth) {
        size -= 2;
        context.font = `900 ${size}px Arial, sans-serif`;
      }
      context.fillText(text, x, y, maximumWidth);
    }

    async generateMockup() {
      const status = this.query('[data-bbe-mockup-status]');
      status.textContent = 'Generating…';
      const canvas = this.query('[data-bbe-mockup-canvas]');
      canvas.width = 1200;
      canvas.height = 1200;
      let context = canvas.getContext('2d');
      context.fillStyle = '#fff';
      context.fillRect(0, 0, 1200, 1200);

      const listingImage = this.query('[data-bbe-listing-image]');
      let usedListingImage = false;
      if (this.state.listingImageReady && listingImage.complete) {
        try {
          this.drawContained(context, listingImage, 1200, 1010);
          context.getImageData(0, 0, 1, 1);
          usedListingImage = true;
        } catch {
          canvas.width = 1200;
          canvas.height = 1200;
          context = canvas.getContext('2d');
          context.fillStyle = '#fff';
          context.fillRect(0, 0, 1200, 1200);
        }
      }
      if (!usedListingImage) await this.drawFallbackHat(context, 1200, 1010);

      const x = this.state.placement.x * 1200;
      const y = this.state.placement.y * 1010;
      const maximumWidth = this.state.placement.size * 1200;
      if (this.state.front.url) {
        const artwork = await this.loadImage(this.state.front.url);
        const scale = Math.min(maximumWidth / artwork.naturalWidth, (this.state.placement.size * 620) / artwork.naturalHeight);
        const width = artwork.naturalWidth * scale;
        const height = artwork.naturalHeight * scale;
        context.save();
        context.globalCompositeOperation = 'multiply';
        context.drawImage(artwork, x - width / 2, y - height / 2, width, height);
        context.restore();
      } else {
        this.drawMockupText(context, this.state.front.text, x, y, maximumWidth);
      }

      const variant = this.currentVariant();
      context.fillStyle = 'rgba(255,255,255,.94)';
      context.fillRect(0, 1010, 1200, 190);
      context.fillStyle = '#151515';
      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';
      context.font = '900 40px Arial, sans-serif';
      context.fillText(this.settings.productTitle, 62, 1085, 1076);
      context.fillStyle = '#6f6b63';
      context.font = '600 26px Arial, sans-serif';
      context.fillText(`${variant.public_title || variant.title}  •  Placement preview only`, 62, 1135, 1076);
      context.fillText('Final embroidery proof required before production', 62, 1175, 1076);

      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob((output) => output ? resolve(output) : reject(new Error('The placement preview could not be exported.')), 'image/png', .92);
      });
      if (this.state.generatedMockup.url) URL.revokeObjectURL(this.state.generatedMockup.url);
      this.state.generatedMockup.blob = blob;
      this.state.generatedMockup.url = URL.createObjectURL(blob);
      const image = this.query('[data-bbe-mockup-image]');
      image.src = this.state.generatedMockup.url;
      image.hidden = false;
      status.textContent = usedListingImage ? 'Ready from selected listing' : 'Ready with universal hat';
      return blob;
    }

    renderStep() {
      this.queryAll('[data-bbe-step]').forEach((panel) => { panel.hidden = Number(panel.dataset.bbeStep) !== this.state.step; });
      this.queryAll('[data-bbe-progress]').forEach((item) => {
        const number = Number(item.dataset.bbeProgress);
        item.classList.toggle('is-active', number === this.state.step);
        item.classList.toggle('is-complete', number < this.state.step);
        item.textContent = number < this.state.step ? '✓' : String(number + 1);
      });
      this.query('[data-bbe-back]').hidden = this.state.step === 0;
      this.query('[data-bbe-next] span').textContent = this.state.step === 3 ? this.settings.labels.addToCart : this.settings.labels.continue;
      if (this.state.step === 3) {
        this.renderReview();
        this.generateMockup().catch(() => {
          this.query('[data-bbe-mockup-status]').textContent = 'Preview unavailable — original artwork is still saved';
        });
      }
    }

    render() {
      const sideDetails = this.query('[data-bbe-details="side"]');
      const backDetails = this.query('[data-bbe-details="back"]');
      if (sideDetails) sideDetails.hidden = !this.state.side.enabled;
      if (backDetails) backDetails.hidden = !this.state.back.enabled;
      this.query('[data-bbe-quantity]').value = this.state.quantity;
      this.renderPreview();
      this.renderPricing();
      this.renderStep();
    }

    showError(message) {
      const error = this.query('[data-bbe-error]');
      error.textContent = message;
      error.hidden = false;
    }

    hideError() {
      const error = this.query('[data-bbe-error]');
      error.hidden = true;
      error.textContent = '';
    }

    validate() {
      if (this.state.step === 0 && !this.state.front.file && !this.state.front.text.trim()) return this.settings.labels.frontRequired;
      if (this.state.step === 1 && this.state.side.enabled && !this.state.side.file && !this.state.side.text.trim()) return this.settings.labels.sideRequired;
      if (this.state.step === 1 && this.state.back.enabled && !this.state.back.file && !this.state.back.text.trim()) return this.settings.labels.backRequired;
      if (this.state.step === 2 && (!Number.isInteger(this.state.quantity) || this.state.quantity < 1 || this.state.quantity > this.settings.maxQuantity)) return this.settings.labels.invalidQuantity;
      return '';
    }

    changeStep(next) {
      const update = () => {
        this.state.step = Math.max(0, Math.min(3, next));
        this.hideError();
        this.renderStep();
      };
      if (document.startViewTransition) document.startViewTransition(update);
      else update();
    }

    setFile(area, file) {
      if (!file) return;
      if (file.size > 20 * 1024 * 1024) {
        this.showError('Artwork files must be 20 MB or smaller.');
        return;
      }
      if (this.state[area].url) URL.revokeObjectURL(this.state[area].url);
      this.state[area].file = file;
      this.state[area].url = file.type === 'application/pdf' ? '' : URL.createObjectURL(file);
      this.query(`[data-bbe-file-label="${area}"]`).textContent = file.name;
      this.setView('front');
      this.hideError();
    }

    selectedAddOnsMissingVariants() {
      const missing = [];
      if (this.state.side.enabled && !this.settings.addOns.side.variantId) missing.push(this.settings.addOns.side.label);
      if (this.state.back.enabled && !this.settings.addOns.back.variantId) missing.push(this.settings.addOns.back.label);
      if (this.state.style === 'puff' && !this.settings.addOns.puff.variantId) missing.push(this.settings.addOns.puff.label);
      return missing;
    }

    addProperty(formData, key, value) {
      if (value !== undefined && value !== null && String(value).trim()) formData.append(`properties[${key}]`, value);
    }

    async submit() {
      const missing = this.selectedAddOnsMissingVariants();
      if (missing.length) throw new Error(`${this.settings.labels.missingVariant} ${missing.join(', ')}`);
      const configurationId = `BBE-${Date.now().toString(36).toUpperCase()}-${crypto.getRandomValues(new Uint32Array(1))[0].toString(36).toUpperCase()}`;
      const formData = new FormData();
      formData.append('id', this.state.variantId);
      formData.append('quantity', String(this.state.quantity));
      this.addProperty(formData, 'Configuration ID', configurationId);
      this.addProperty(formData, 'Front text', this.state.front.text.trim());
      this.addProperty(formData, 'Side embroidery', this.state.side.enabled ? `${this.state.side.placement} side` : 'No');
      this.addProperty(formData, 'Side text', this.state.side.enabled ? this.state.side.text.trim() : '');
      this.addProperty(formData, 'Back embroidery', this.state.back.enabled ? 'Yes' : 'No');
      this.addProperty(formData, 'Back text', this.state.back.enabled ? this.state.back.text.trim() : '');
      this.addProperty(formData, 'Embroidery style', this.state.style === 'puff' ? this.settings.labels.puff : this.settings.labels.standard);
      this.addProperty(formData, 'Thread colors / special instructions', this.state.notes.trim());
      this.addProperty(formData, 'Preview disclaimer', this.settings.labels.universalDisclaimer);
      this.addProperty(formData, 'Proof required', this.settings.labels.proofRequired);
      this.addProperty(formData, 'Artwork placement', `${Math.round(this.state.placement.x * 100)}% across, ${Math.round(this.state.placement.y * 100)}% down, ${Math.round(this.state.placement.size * 100)}% size`);
      if (this.state.front.file) formData.append('properties[Front artwork]', this.state.front.file, this.state.front.file.name);
      if (this.state.side.enabled && this.state.side.file) formData.append('properties[Side artwork]', this.state.side.file, this.state.side.file.name);
      if (this.state.back.enabled && this.state.back.file) formData.append('properties[Back artwork]', this.state.back.file, this.state.back.file.name);
      try {
        const mockupBlob = await this.generateMockup();
        formData.append('properties[Generated placement mockup]', mockupBlob, `${configurationId}-placement-preview.png`);
      } catch {
        this.addProperty(formData, 'Generated mockup status', 'Unavailable — use original artwork and placement coordinates');
      }

      const root = window.Shopify?.routes?.root || '/';
      const endpoint = `${root}cart/add.js`.replace('//cart', '/cart');
      const response = await fetch(endpoint, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || this.settings.labels.addFailed);
      }

      const items = [];
      const addItem = (enabled, addOn, label) => {
        if (!enabled) return;
        items.push({ id: Number(addOn.variantId), quantity: this.state.quantity, properties: { 'Configuration ID': configurationId, 'Applied to': this.settings.productTitle, 'Customization add-on': label } });
      };
      addItem(this.state.side.enabled, this.settings.addOns.side, `${this.state.side.placement} side embroidery`);
      addItem(this.state.back.enabled, this.settings.addOns.back, 'Back embroidery');
      addItem(this.state.style === 'puff', this.settings.addOns.puff, this.settings.labels.puff);
      if (items.length) {
        const addOnResponse = await fetch(endpoint, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        if (!addOnResponse.ok) throw new Error(this.settings.labels.addFailed);
      }
      window.location.assign(`${root}cart`.replace('//cart', '/cart'));
    }

    async next() {
      this.hideError();
      const error = this.validate();
      if (error) {
        this.showError(error);
        return;
      }
      if (this.state.step < 3) {
        this.changeStep(this.state.step + 1);
        return;
      }
      const button = this.query('[data-bbe-next]');
      button.disabled = true;
      this.query('[data-bbe-next] span').textContent = this.settings.labels.adding;
      try {
        await this.submit();
      } catch (submitError) {
        this.showError(submitError.message || this.settings.labels.addFailed);
        button.disabled = false;
        this.query('[data-bbe-next] span').textContent = this.settings.labels.addToCart;
      }
    }

    open() {
      this.syncVariant();
      this.render();
      this.dialog.showModal();
    }

    bind() {
      this.query('[data-bbe-open]').addEventListener('click', () => this.open());
      this.query('[data-bbe-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      this.query('[data-bbe-next]').addEventListener('click', () => this.next());
      this.query('[data-bbe-back]').addEventListener('click', () => this.changeStep(this.state.step - 1));
      const artwork = this.query('[data-bbe-artwork]');
      const stage = this.query('[data-bbe-stage]');
      let activePointer = null;
      const moveArtwork = (event) => {
        if (this.state.view !== 'front') return;
        const bounds = stage.getBoundingClientRect();
        this.state.placement.x = Math.max(.14, Math.min(.86, (event.clientX - bounds.left) / bounds.width));
        this.state.placement.y = Math.max(.16, Math.min(.7, (event.clientY - bounds.top) / bounds.height));
        this.renderPreview();
      };
      artwork.addEventListener('pointerdown', (event) => {
        if (this.state.view !== 'front') return;
        activePointer = event.pointerId;
        artwork.setPointerCapture(activePointer);
        artwork.classList.add('is-dragging');
        moveArtwork(event);
      });
      artwork.addEventListener('pointermove', (event) => { if (event.pointerId === activePointer) moveArtwork(event); });
      const finishDrag = (event) => {
        if (event.pointerId !== activePointer) return;
        activePointer = null;
        artwork.classList.remove('is-dragging');
      };
      artwork.addEventListener('pointerup', finishDrag);
      artwork.addEventListener('pointercancel', finishDrag);
      this.query('[data-bbe-artwork-size]').addEventListener('input', (event) => {
        this.state.placement.size = Number(event.target.value) / 100;
        this.renderPreview();
      });
      this.query('[data-bbe-placement-reset]').addEventListener('click', () => {
        this.state.placement = { x: .5, y: .39, size: .26 };
        this.renderPreview();
      });
      this.queryAll('[data-bbe-file]').forEach((input) => input.addEventListener('change', () => this.setFile(input.dataset.bbeFile, input.files[0])));
      this.queryAll('[data-bbe-text]').forEach((input) => input.addEventListener('input', () => { this.state[input.dataset.bbeText].text = input.value; this.renderPreview(); }));
      this.queryAll('[data-bbe-toggle]').forEach((input) => input.addEventListener('change', () => {
        const area = input.dataset.bbeToggle;
        this.state[area].enabled = input.checked;
        this.render();
      }));
      this.queryAll(`input[name="bbe-side-${this.root.dataset.sectionId}"]`).forEach((input) => input.addEventListener('change', () => { if (input.checked) this.state.side.placement = input.value; }));
      this.queryAll(`input[name="bbe-style-${this.root.dataset.sectionId}"]`).forEach((input) => input.addEventListener('change', () => { if (input.checked) { this.state.style = input.value; this.renderPricing(); } }));
      this.query('[data-bbe-quantity]').addEventListener('input', (event) => { this.state.quantity = Math.max(1, Math.min(this.settings.maxQuantity, Number(event.target.value) || 1)); this.renderPricing(); });
      this.queryAll('[data-bbe-quantity-change]').forEach((button) => button.addEventListener('click', () => { this.state.quantity = Math.max(1, Math.min(this.settings.maxQuantity, this.state.quantity + Number(button.dataset.bbeQuantityChange))); this.render(); }));
      this.query('[data-bbe-notes]').addEventListener('input', (event) => { this.state.notes = event.target.value; });
      document.addEventListener('change', (event) => { if (event.target.matches('form[action*="/cart/add"] [name="id"]') && !this.root.contains(event.target)) { this.state.variantId = String(event.target.value); this.syncVariant(); this.renderPricing(); this.renderPreview(); } });
    }
  }

  document.querySelectorAll('.bbe-root').forEach((root) => {
    if (!root.bbeConfigurator) root.bbeConfigurator = new BBEHatConfigurator(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
